var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalidDomain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5035 17.4873C19.5782 17.4873 18.7908 17.8111 18.1415 18.4587C17.4917 19.1062 17.1668 19.8924 17.1668 20.8173C17.1668 21.7427 17.4906 22.53 18.1382 23.1793C18.7857 23.8291 19.5719 24.154 20.4968 24.154C21.4222 24.154 22.2095 23.8302 22.8588 23.1827C23.5086 22.5351 23.8335 21.7487 23.8335 20.8233C23.8335 19.8984 23.5097 19.1111 22.8622 18.4613C22.2146 17.812 21.4284 17.4873 20.5035 17.4873ZM20.5035 42.5127C19.5782 42.5127 18.7908 42.8364 18.1415 43.484C17.4917 44.1315 17.1668 44.918 17.1668 45.8433C17.1668 46.7682 17.4906 47.5555 18.1382 48.2053C18.7857 48.8547 19.5719 49.1793 20.4968 49.1793C21.4222 49.1793 22.2095 48.8555 22.8588 48.208C23.5086 47.5604 23.8335 46.7742 23.8335 45.8493C23.8335 44.924 23.5097 44.1367 22.8622 43.4873C22.2146 42.8375 21.4284 42.5127 20.5035 42.5127ZM12.1928 10.154H52.8075C53.4759 10.154 54.0364 10.3795 54.4888 10.8307C54.9408 11.2813 55.1668 11.84 55.1668 12.5067V28.974C55.1668 29.6958 54.9408 30.2951 54.4888 30.772C54.0364 31.2489 53.4759 31.4873 52.8075 31.4873H12.1928C11.5244 31.4873 10.9639 31.2489 10.5115 30.772C10.0595 30.2951 9.8335 29.6958 9.8335 28.974V12.5067C9.8335 11.84 10.0595 11.2813 10.5115 10.8307C10.9639 10.3795 11.5244 10.154 12.1928 10.154ZM13.8335 14.154V27.4873H51.1668V14.154H13.8335ZM12.1928 35.1793H52.7562C53.4606 35.1793 54.0384 35.4153 54.4895 35.8873C54.9411 36.3589 55.1668 36.9435 55.1668 37.6413V53.9487C55.1668 54.7042 54.9411 55.3204 54.4895 55.7973C54.0384 56.2742 53.4606 56.5127 52.7562 56.5127H12.2442C11.5397 56.5127 10.9619 56.2742 10.5108 55.7973C10.0593 55.3204 9.8335 54.7042 9.8335 53.9487V37.6413C9.8335 36.9435 10.0506 36.3589 10.4848 35.8873C10.9191 35.4153 11.4884 35.1793 12.1928 35.1793ZM13.8335 39.1793V52.5127H51.1668V39.1793H13.8335Z",
    fill: "#FF4444"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.24696,
    y1: 64.1701,
    x2: 63.9393,
    y2: 6.47781,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.93934,
    y1: 58.4009,
    x2: 61.6316,
    y2: 0.708583,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.93934,
    y1: 61.8624,
    x2: 61.6316,
    y2: 4.1701,
    stroke: "#FF4444",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidDomain);
export default __webpack_public_path__ + "static/media/invalid-domain.888f32ad9f962739f9cc17e6e5ced32a.svg";
export { ForwardRef as ReactComponent };